import { render } from "./TeachersListEmpty.vue?vue&type=template&id=11d9b4c1&scoped=true"
import script from "./TeachersListEmpty.vue?vue&type=script&lang=js"
export * from "./TeachersListEmpty.vue?vue&type=script&lang=js"

import "./TeachersListEmpty.vue?vue&type=style&index=0&id=11d9b4c1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d9b4c1"]])

export default __exports__